import { useLang } from "@/i18n";
import buildTime from "@/buildTime.json";

function formatDeployTime(lang) {
  const raw = buildTime?.time;
  const d = raw ? new Date(raw) : new Date();
  if (isNaN(d.getTime())) return raw || "";
  return d.toLocaleString(lang === "sk" ? "sk-SK" : "en-GB", {
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit",
  });
}

export function Footer() {
  const { t, lang } = useLang();
  return (
    <footer className="border-t border-border">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 pt-8 pb-28 sm:pb-8 flex flex-col items-center gap-2">
        <span className="font-data text-xs text-gray-400 tracking-wide">{t("footer.tagline")}</span>
        <span className="font-data text-xs text-gray-400" data-testid="deploy-time">
          {t("footer.lastUpdate")} {formatDeployTime(lang)}
        </span>
      </div>
    </footer>
  );
}
